// extracted by mini-css-extract-plugin
module.exports = {"SectionImageText":"SectionImageText_SectionImageText__ln0no"};